<template>
    <v-layout wrap>
        <v-flex xs12>
            <div class="font-weight-light title">
                <img :src="event.imgurl" height="100" /><br/>
                Register<br/>
                <span v-for="p in players" :key="p.partkey" class="mr-1 font-weight-light headline">{{p.firstname}} {{p.lastname}}</span>
                <br/>
                for {{event.name}} - {{activesku.attributes.name}}
            </div>
            <div>
                {{event.description}}<br/>
                {{activesku.metadata.date}}
                {{activesku.metadata.time}}<br/>

            </div>
            <div class="font-weight-light headline">
                Price:  ${{activesku.price/100}}
            </div>
        </v-flex>
        <v-flex xs12>
            <BaseBtn @click="confirm">Confirm and <v-icon class="ml-2">mdi-arrow-right</v-icon></BaseBtn>
        </v-flex>
    </v-layout>
</template>

<script>
  import BaseBtn from "../BaseBtn";
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex'
  export default {
    components: {BaseBtn},
    name: "TeamCard",
    data() {
      return {}
    },
    computed:{
      ...mapState(['activeevent','orders','activesku']),
      step(){
        return this.$store.state.step
      },
      event(){
        return this.activeevent.event
      },
      skus(){
        return this.activeevent.skus
      },
      product(){
        return this.activeevent.product
      },
      players(){
        return this.$store.state.registrants
      }
    },
    mounted() {
    },
    methods: {
      confirm(){
        this.$store.commit('setRegistrationStep',3)
      }
    }
  }
</script>

<style scoped>

</style>